import { ThemeProvider as NextThemesProvider } from 'next-themes'
import { useEffect } from 'react'

import { isProd } from '@/utils/common'

interface ThemeProviderProps {
    children: React.ReactNode
}

export function ThemeProvider({ children }: ThemeProviderProps) {
    useEffect(() => {
        // Force light theme in production
        if (isProd()) {
            document.documentElement.classList.remove('dark')
            document.documentElement.setAttribute('data-theme', 'light')
        }
    }, [])

    return (
        <NextThemesProvider
            attribute="class"
            defaultTheme={isProd() ? 'light' : 'system'}
            enableSystem={!isProd()}
            disableTransitionOnChange={false}
            forcedTheme={isProd() ? 'light' : undefined}
        >
            {children}
        </NextThemesProvider>
    )
}
